import {
  type PayloadAction,
  createSelector,
  createSlice
} from "@reduxjs/toolkit";

import type { RootState } from "app/store";

export interface ActiveVisitDrawerState {
  collapsed: boolean;
  activeAppointmentId: number | null;
}

const initialState: ActiveVisitDrawerState = {
  collapsed: true,
  activeAppointmentId: null
};

export const activeVisitDrawerSlice = createSlice({
  name: "active-visit-drawer",
  initialState,
  reducers: {
    toggleCollapse: (state) => {
      state.collapsed = !state.collapsed;
    },
    collapseDrawer: (state) => {
      state.collapsed = true;
    },
    setActiveAppointmentId: (state, action: PayloadAction<number>) => {
      state.activeAppointmentId = action.payload;
    },
    resetActiveVisitDrawer: () => initialState
  }
});

export const {
  toggleCollapse,
  collapseDrawer,
  setActiveAppointmentId,
  resetActiveVisitDrawer
} = activeVisitDrawerSlice.actions;

const selectActiveVisitDrawer = (state: RootState) => state.activeVisitDrawer;

export const selectActiveVisitDrawerCollapsed = createSelector(
  selectActiveVisitDrawer,
  (s) => s.collapsed
);

export const selectActiveVisitDrawerActiveAppointmentId = createSelector(
  selectActiveVisitDrawer,
  (s) => s.activeAppointmentId
);

export default activeVisitDrawerSlice.reducer;
